import apiClient from "@/api/client";
import type { ExternalCostRequest, ExternalCostType } from "../types";

export const externalCostsApi = {
  list: (orderId: string) =>
    apiClient
      .get<{ data: ExternalCostRequest[] }>("/orders/external-costs/", { params: { order: orderId } })
      .then((r) => r.data.data),

  create: (payload: {
    order: string;
    cost_type: ExternalCostType;
    description: string;
    amount_estimated: string;
    justification: string;
  }) =>
    apiClient.post<{ data: ExternalCostRequest }>("/orders/external-costs/", payload).then((r) => r.data.data),

  approve: (id: string, approvedAmount: string, approvalNote?: string) =>
    apiClient
      .post<{ data: ExternalCostRequest }>(`/orders/external-costs/${id}/approve/`, {
        approved_amount: approvedAmount,
        approval_note: approvalNote ?? "",
      })
      .then((r) => r.data.data),

  reject: (id: string, rejectionComment: string) =>
    apiClient
      .post<{ data: ExternalCostRequest }>(`/orders/external-costs/${id}/reject/`, { rejection_comment: rejectionComment })
      .then((r) => r.data.data),

  submitInvoice: (id: string, amountActual: string, settlementMethod?: string) => {
    const fd = new FormData();
    fd.append("amount_actual", amountActual);
    if (settlementMethod) fd.append("settlement_method", settlementMethod);
    return apiClient
      .post<{ data: ExternalCostRequest }>(`/orders/external-costs/${id}/submit-invoice/`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data.data);
  },

  settle: (id: string, settlementNote?: string) =>
    apiClient
      .post<{ data: ExternalCostRequest }>(`/orders/external-costs/${id}/settle/`, {
        settlement_note: settlementNote ?? "",
      })
      .then((r) => r.data.data),
};
